import Swiper from 'swiper/bundle';

const sliderWines = document.querySelector(`.js--slider-wines`);

if(sliderWines){
  const sliderWinesPagination = sliderWines.querySelector(`.swiper-pagination`);

  const winesSwiper = new Swiper(sliderWines, {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    speed: 750,
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true
    },
    pagination: {
      el: sliderWinesPagination,
      clickable: true,
    },
    navigation: {
      nextEl: '.js--slider-wines__next',
      prevEl: '.js--slider-wines__prev',
    },
  });
}